import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBCol,
  MDBRow,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import Body from "../../../components/body/BodyPage";
import MainLinks from "../../../components/navlinks/MainLinks";
import EditCallFlow from "./EditCallFlow";
function CallFlowGeneralSettings(props) {
  const section1 = useRef(null);
  const section2 = useRef(null);
  const containerRef = useRef(null);
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [basicActive, setBasicActive] = useState("tab1");

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };
  const location = useLocation();

  console.log(props);
  if (!props || !props.call_flow) {
    props = location.state;
  }
  if (!props || !props.call_flow) {
    props = { call_flow: {} };
  }
  return (
    <React.Fragment>
      <MainLinks active={2} />
      <Body
        tablinks={2}
        sublink={41}
        content={
          <>
            <section className="mb-3">
              <div className="card card-height">
                <div className="card-header py-3 px-0">
                  <h5 className="mb-0 ">
                    <MDBBreadcrumb>
                      <MDBBreadcrumbItem>
                        <a href="/pslanding">
                          <strong>{t("phoneSystem")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem active>
                        <a href="/callflowlanding">
                          <strong>{t("CallFlow")}</strong>
                        </a>
                      </MDBBreadcrumbItem>
                      <MDBBreadcrumbItem>
                        <strong>{props.call_flow.name}</strong>
                      </MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                  </h5>
                </div>
                <div className="card-body px-0">
                  <div class="pb-2">
                    <h5 class="fw-600 mt-2 ">{props.call_flow.name}</h5>
                    <p class="mt-2 text-secondary">Extension: {props.call_flow.extension}</p>
                  </div>

                  <MDBTabs className="mb-3">
                    <MDBTabsItem>
                      <MDBTabsLink
                        onClick={() => handleBasicClick("tab1")}
                        active={basicActive === "tab1"}
                      >
                        {t("settings")}
                      </MDBTabsLink>
                    </MDBTabsItem>
                  </MDBTabs>

                  <MDBTabsContent>
                    <MDBTabsPane open={basicActive === "tab1"}>
                      <MDBRow>
                        <MDBCol
                          size="2"
                          md="2"
                          lg="2"
                          sm="12"
                          className="col-sm-100 pr-0 leftTabs"
                        >
                          <MDBScrollspy
                            container={containerRef}
                            defaultActive="general"
                          >
                            <MDBScrollspyLink targetRef={section1} id="general">
                              {t("general")}
                            </MDBScrollspyLink>
                          </MDBScrollspy>
                        </MDBCol>

                        <MDBCol
                          size="12"
                          md="10"
                          sm="12"
                          pr-0
                          className="col-sm-100 pr-0 leftTabContent"
                        >
                          <div
                            id="element"
                            ref={containerRef}
                            className="scrollspy-example"
                          >
                            <section ref={section1} id="section-1">
                              <div className="general-settings">
                                {t("general")}
                              </div>
                              <EditCallFlow call_flow={props.call_flow} />
                            </section>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    </MDBTabsPane>
                  </MDBTabsContent>
                </div>
              </div>
            </section>
          </>
        }
      />
    </React.Fragment>
  );
}
export default CallFlowGeneralSettings;
